import { useMutation } from "@tanstack/react-query";
import { updateUserAccountId } from "../api/global_collections/users";
import { useCurrentUser } from "../hooks/useCurrentUser";

export const useGlobalUserAccountUpdate = () => {
  const currentUser = useCurrentUser();
  return useMutation({
    mutationFn: ({ userId, newAccountId }: { userId: string; newAccountId: string }) =>
      updateUserAccountId(userId, newAccountId, currentUser),
  });
}; 